export default "__VITE_ASSET__D$PfQr9O__"